import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Session } from 'src/app/my-sedgwick';
import { DisplayService } from '../../services/display-service';

@Injectable({
  providedIn: 'root',
})
export class SummaryViewGuard {
  constructor(
    private router: Router,
    private session: Session,
    private displayService: DisplayService,
  ) {}

  async canActivate() {
    await this.session.loadUser();
    const allowed = await this.displayService.summaryView();
    if (allowed) {
      return true;
    } else {
      this.router.navigate(['/unauthorized']);
      return false;
    }
  }
}
